import { HttpErrorResponse } from '@angular/common/http';
import { ApiException, ApiExceptionConstructor } from 'src/core/common/domain/exceptions/api-exception';

export class TaskNotFoundException extends ApiException implements ApiExceptionConstructor {
  constructor(message?: string, error?: HttpErrorResponse | Error) {
    super(message, error);
    this.name = 'TaskNotFoundException';
  }

  static fromError(error: HttpErrorResponse | Error): TaskNotFoundException {
    return new this(error.message, error);
  }
}
